export const Insta = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9176 1H9.0824C4.61819 1 1 4.61883 1 9.0824V22.9176C1 27.3818 4.61883 31 9.08304 31H22.917C27.3812 31 31 27.3812 31 22.917V9.0824C31 4.61819 27.3812 1 22.917 1H22.9176Z"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M15.9998 23.2418C19.9992 23.2418 23.2413 19.9997 23.2413 16.0003C23.2413 12.0009 19.9992 8.75879 15.9998 8.75879C12.0004 8.75879 8.7583 12.0009 8.7583 16.0003C8.7583 19.9997 12.0004 23.2418 15.9998 23.2418Z"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M24.5245 8.2214C25.233 8.2214 25.8073 7.64706 25.8073 6.93858C25.8073 6.2301 25.233 5.65576 24.5245 5.65576C23.816 5.65576 23.2417 6.2301 23.2417 6.93858C23.2417 7.64706 23.816 8.2214 24.5245 8.2214Z"
      fill="white"
    />
  </svg>
);
